import { Flex } from 'antd';
import { useInjection } from 'inversify-react';
import { useState } from 'react';

import { Button, useTheme } from '@desygner/ui-common-components';
import { BottomSheet } from '@desygner/ui-common-components-next';
import { useProjectsStore } from '@desygner/ui-features-projects';

import { RestrictionsManager } from '../../../../../../core/viewer/restrictions-manager';
import { TYPES } from '../../../../../../inversify.types';
import { ThemeModeSwitch } from '../../../../ThemeModeSwitch/ThemeModeSwitch';
import { ProjectActions } from '../ProjectActions/ProjectActions';

export const BottomSheetMenu = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const projectName = useProjectsStore((state) => state.project.currentProject?.name);

  function handleToggle() {
    setOpen((prev) => !prev);
  }

  return (
    <>
      <Button
        variant="outline"
        size="Small"
        onClick={handleToggle}
        action="menu"
        dataset={{
          menu: open ? 'close' : 'open',
        }}
        icon={{
          name: 'more-options---20',
          angle: 90,
        }}
      />
      <BottomSheet
        data-testid="bottom-sheet-menu"
        styledTitle={projectName}
        height="auto"
        content={
          <Flex vertical gap={theme.Spacing.Size.Medium}>
            <ThemeModeSwitch type="button" />
            <ProjectActions type="bottomsheet" />
          </Flex>
        }
        onHandleClose={handleToggle}
        isOpened={open}
      />
    </>
  );
};
